"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_intl_1 = require("react-intl");
// For notifications the defaultMessage will not be passed in code, so it should not be empty '', so that phraseapp does its thing
exports.default = (0, react_intl_1.defineMessages)({
    msgTitleNewDatapool: {
        id: 'notifications.title.new_datapool',
        defaultMessage: 'New Datapool',
    },
    msgDescriptionNewDatapool: {
        id: 'notifications.description.datapool_was_added',
        defaultMessage: 'Datapool {datapoolName} was added',
    },
    msgTitleNewCassandraKeyspaceCreated: {
        id: 'notifications.title.cassandra_keyspace_creation',
        defaultMessage: 'Cassandra Keyspace',
    },
    msgDescriptionNewCassandraKeyspaceCreated: {
        id: 'notifications.description.cassandra_keyspace_created',
        defaultMessage: 'Cassandra Keyspace {keyspaceName} has been created',
    },
    msgTitleNewCassandraKeyspaceExists: {
        id: 'notifications.title.cassandra_keyspace_exists',
        defaultMessage: 'Cassandra Keyspace',
    },
    msgDescriptionNewCassandraKeyspaceExists: {
        id: 'notifications.description.cassandra_keyspace_exists',
        defaultMessage: 'Cassandra Keyspace {keyspaceName} already exists',
    },
    msgTitleNewCassandraKeyspaceError: {
        id: 'notifications.title.cassandra_keyspace_error',
        defaultMessage: 'Cassandra Keyspace',
    },
    msgDescriptionNewCassandraKeyspaceError: {
        id: 'notifications.description.cassandra_keyspace_error',
        defaultMessage: 'Cassandra Keyspace {keyspaceName} could not be created',
    },
    msgTitleNewCassandraKeyspaceNoDefaultDataSource: {
        id: 'notifications.title.no_default_cassandra_data_source',
        defaultMessage: 'Cassandra Keyspace',
    },
    msgDescriptionNewCassandraKeyspaceNoDefaultDataSource: {
        id: 'notifications.description.no_default_cassandra_data_source',
        defaultMessage: "No default Cassandra Data Source, couldn't create the Keyspace",
    },
    msgTitleNewDatapoolFailed: {
        id: 'notifications.title.new_datapool_failed',
        defaultMessage: 'New Datapool failed',
    },
    msgDescriptionNewDatapoolFailed: {
        id: 'notifications.description.new_datapool_failed',
        defaultMessage: 'Datapool {datapoolName} failed to be added correctly',
    },
    msgTitlePermissionSetErr: {
        id: 'notifications.title.permissions.set.error',
        defaultMessage: 'Permissions could not be set',
    },
    msgDescriptionPermissionSetErr: {
        id: 'notifications.description.permissions.set.error.details',
        defaultMessage: 'Permissions could not be set',
    },
    msgTitlePermissionSyncErr: {
        id: 'notifications.title.permissions.sync.error',
        defaultMessage: 'Permissions could not be synced',
    },
    msgDescriptionPermissionSyncErr: {
        id: 'notifications.description.permissions.sync.error.details',
        defaultMessage: 'Will automatically retry later.',
    },
    msgTitleJobGroupAddSuccess: {
        id: 'notifications.title.jobGroup_add_success',
        defaultMessage: 'Job Group added',
    },
    msgDescriptionJobGroupAddSuccess: {
        id: 'notifications.description.jobGroup_add_success',
        defaultMessage: 'The Job Group was added successfully',
    },
    msgTitleJobGroupAddFailure: {
        id: 'notifications.title.jobGroup_add_failure',
        defaultMessage: 'Adding Job Group failed',
    },
    msgTitleJobGroupUpdateSuccess: {
        id: 'notifications.title.jobGroup_update_success',
        defaultMessage: 'Job Group updated',
    },
    msgDescriptionJobGroupUpdateSuccess: {
        id: 'notifications.description.jobGroup_update_success',
        defaultMessage: 'The Job Group was updated successfully',
    },
    msgTitleJobGroupUpdateFailure: {
        id: 'notifications.title.jobGroup_update_failure',
        defaultMessage: 'Updating Job Group failed',
    },
    msgTitleJobGroupDeleteSuccess: {
        id: 'notifications.title.jobGroup_delete_success',
        defaultMessage: 'Job Group deleted',
    },
    msgDescriptionJobGroupDeleteSuccess: {
        id: 'notifications.description.jobGroup_delete_success',
        defaultMessage: 'The Job Group was deleted successfully',
    },
    msgTitleJobGroupDeleteFailure: {
        id: 'notifications.title.jobGroup_delete_failure',
        defaultMessage: 'Deleting Job Group failed',
    },
    msgTitleJobGroupRunSuccess: {
        id: 'notifications.title.jobGroup_run_success',
        defaultMessage: 'Job Group triggered',
    },
    msgDescriptionJobGroupRunSuccess: {
        id: 'notifications.description.jobGroup_run_success',
        defaultMessage: 'The Job Group was successfully added to the Job Queue',
    },
    msgTitleJobGroupRunFailure: {
        id: 'notifications.title.jobGroup_run_failure',
        defaultMessage: 'Triggering Job Group failed',
    },
    msgTitleScheduleAddSuccess: {
        id: 'notifications.title.schedule_add_success',
        defaultMessage: 'Schedule added',
    },
    msgDescriptionScheduleAddSuccess: {
        id: 'notifications.description.schedule_add_success',
        defaultMessage: 'The Schedule was added successfully',
    },
    msgTitleScheduleAddFailure: {
        id: 'notifications.title.schedule_add_failure',
        defaultMessage: 'Adding Schedule failed',
    },
    msgTitleScheduleUpdateSuccess: {
        id: 'notifications.title.schedule_update_success',
        defaultMessage: 'Schedule updated',
    },
    msgDescriptionScheduleUpdateSuccess: {
        id: 'notifications.description.schedule_update_success',
        defaultMessage: 'The Schedule was updated successfully',
    },
    msgTitleScheduleUpdateFailure: {
        id: 'notifications.title.schedule_update_failure',
        defaultMessage: 'Updating Schedule failed',
    },
    msgTitleScheduleDeleteSuccess: {
        id: 'notifications.title.schedule_delete_success',
        defaultMessage: 'Schedule deleted',
    },
    msgDescriptionScheduleDeleteSuccess: {
        id: 'notifications.description.schedule_delete_success',
        defaultMessage: 'The Schedule was deleted successfully',
    },
    msgTitleScheduleDeleteFailure: {
        id: 'notifications.title.schedule_delete_failure',
        defaultMessage: 'Deleting Schedule failed',
    },
    msgTitleEditedHabitat: {
        id: 'notifications.title.edited_habitat',
        defaultMessage: 'Edit Habitat',
    },
    msgDescriptionEditedHabitat: {
        id: 'notifications.description.habitat_was_edited',
        defaultMessage: 'Habitat {habitatName} was edited',
    },
    msgTitleDeletedHabitat: {
        id: 'notifications.title.deleted_habitat',
        defaultMessage: 'Delete Habitat',
    },
    msgDescriptionDeletedHabitat: {
        id: 'notifications.description.habitat_was_deleted',
        defaultMessage: 'Habitat {habitatName} was deleted',
    },
    msgTitleDeletedHabitatFailed: {
        id: 'notifications.title.deleted_habitat_fail',
        defaultMessage: 'Delete Habitat failed',
    },
    msgDescriptionDeletedHabitatFailed: {
        id: 'notifications.description.habitat_could_not_be_deleted',
        defaultMessage: 'The deletion of Habitat {habitatName} failed.',
    },
    msgJobCanceledTitle: {
        id: 'notifications.title.job.canceled',
        defaultMessage: 'Job canceled!',
    },
    msgJobCanceledDescription: {
        id: 'notifications.description.job.canceled',
        defaultMessage: 'The Job was cancelled successfully!',
    },
    msgJobGroupCanceledTitle: {
        id: 'notifications.title.jobgroup.canceled',
        defaultMessage: 'Job Group canceled!',
    },
    msgJobGroupCanceledDescription: {
        id: 'notifications.description.jobgroup.canceled',
        defaultMessage: 'The Job Group was cancelled successfully!',
    },
    msgTitleUploadFile: {
        id: 'notifications.title.upload_file_s3',
        defaultMessage: 'Upload File',
    },
    msgDescriptionUploadFile: {
        id: 'notifications.description.upload_file_s3',
        defaultMessage: 'Starting file upload to S3',
    },
    msgDescriptionUploadFileSuccess: {
        id: 'notifications.description.upload_file_s3_success',
        defaultMessage: 'File upload to S3 completed',
    },
    msgDescriptionUploadFileFailure: {
        id: 'notifications.description.upload_file_s3_failure',
        defaultMessage: 'File upload to S3 failed',
    },
    msgTitleUploadFileCass: {
        id: 'notifications.title.upload_file_cass',
        defaultMessage: 'Upload File',
    },
    msgDescriptionUploadFileCass: {
        id: 'notifications.description.upload_file_cass',
        defaultMessage: 'Starting file upload to Cassandra',
    },
    msgDescriptionUploadFileCassSuccess: {
        id: 'notifications.description.upload_file_cass_success',
        defaultMessage: 'File upload to Cassandra completed',
    },
    msgDescriptionUploadFileCassFailure: {
        id: 'notifications.description.upload_file_cass_failure',
        defaultMessage: 'File upload to Cassandra failed',
    },
    msgTitleCCBuildTriggered: {
        id: 'notifications.title.CCBuildTriggered',
        defaultMessage: 'Triggered successfully',
    },
    msgDescriptionCCBuildTriggered: {
        id: 'notifications.description.CCBuildTriggered',
        defaultMessage: 'The code capsule build was triggered successfully',
    },
    msgTitleCCBuildTriggeredFailed: {
        id: 'notifications.title.CCBuildTriggered_failed',
        defaultMessage: 'Code capsule build failed',
    },
    msgDescriptionCCBuildTriggeredFailed: {
        id: 'notifications.description.CCBuildTriggered_failed',
        defaultMessage: 'The code capsule build trigger failed',
    },
    msgTitleAppBuildTriggered: {
        id: 'notifications.title.AppBuildTriggered',
        defaultMessage: 'Triggered successfully',
    },
    msgDescriptionAppBuildTriggered: {
        id: 'notifications.description.AppBuildTriggered',
        defaultMessage: 'The app capsule build was triggered successfully',
    },
    msgTitleAppBuildTriggeredFailed: {
        id: 'notifications.title.AppBuildTriggered_failed',
        defaultMessage: 'App build failed',
    },
    msgDescriptionAppBuildTriggeredFailed: {
        id: 'notifications.description.AppBuildTriggered_failed',
        defaultMessage: 'The app build trigger failed',
    },
    msgTitleArchetypeBuildTriggered: {
        id: 'notifications.title.ArchetypeBuildTriggered',
        defaultMessage: 'Triggered successfully',
    },
    msgDescriptionArchetypeBuildTriggered: {
        id: 'notifications.description.ArchetypeBuildTriggered',
        defaultMessage: 'The archetype build was triggered successfully',
    },
    msgTitleArchetypeBuildTriggeredFailed: {
        id: 'notifications.title.ArchetypeBuildTriggered_failed',
        defaultMessage: 'Archetype build failed',
    },
    msgDescriptionArchetypeBuildTriggeredFailed: {
        id: 'notifications.description.ArchetypeBuildTriggered_failed',
        defaultMessage: 'The archetype build trigger failed',
    },
    msgTitleTemplateCreateSuccess: {
        id: 'notifications.title.template_create_success',
        defaultMessage: 'Template created',
    },
    msgDescriptionTemplateCreateSuccess: {
        id: 'notifications.description.template_create_success',
        defaultMessage: 'The template was created successfully',
    },
    msgTitleTemplateCreateFailure: {
        id: 'notifications.title.template_create_failure',
        defaultMessage: 'Creating template failed',
    },
    msgDescriptionTemplateCreateFailure: {
        id: 'notifications.description.template_create_failure',
        defaultMessage: 'Unable to create template',
    },
    msgTitleBackupCreateSuccess: {
        id: 'notifications.title.backup_create_success',
        defaultMessage: 'Backup created',
    },
    msgDescriptionBackupCreateSuccess: {
        id: 'notifications.description.backup_create_success',
        defaultMessage: 'The backup was created successfully',
    },
    msgTitleBackupCreateFailure: {
        id: 'notifications.title.backup_create_failure',
        defaultMessage: 'Creating backup failed',
    },
    msgDescriptionBackupCreateFailure: {
        id: 'notifications.description.backup_create_failure',
        defaultMessage: 'Unable to create backup',
    },
    msgTitleAugurAddFailure: {
        id: 'notifications.title.augur_add_failure',
        defaultMessage: 'Adding Augur failed',
    },
    msgDescriptionAugurAddFailure: {
        id: 'notifications.description.augur_add_failure',
        defaultMessage: 'Unable to create augur',
    },
    msgTitleNewAugurExists: {
        id: 'notifications.title.augur_exists',
        defaultMessage: 'Validation error',
    },
    msgDescriptionNewAugurExists: {
        id: 'notifications.description.augur_exists',
        defaultMessage: 'Augur {augurName} already exists',
    },
});
//# sourceMappingURL=notifications.js.map